module.exports = __webpack_public_path__ + "assets/img/20_971.051716ab.jpg";